var utfstring = require("utfstring")


function determineResult(switchCase){
  let result=[]
  switch (switchCase) {
    case 0:
      result[0]=80
      result[1]='<br>兩人棋逢對手，同樣電力十足<br>他甚至比你還更具危險性，是會讓你感到不安的對象。<br><br>男人，大多能言善道，口才十分不錯。<br>也是談笑風生，讓週遭的人有如沐春風之感。<br>這類型的男人也是不折不扣的樂觀主義者<br>認為天塌下來也有人替自己頂著<br>所以人生應是享受樂趣，而不是每天擔憂的。<br><br>女生，特性在於熱情大方，活力充沛。<br>她們的幽默感十足，樂觀積極<br>和她們在一起，經常可以感受到輕鬆愉快的氣氛。<br>而且在擇偶的條件上，通常會開出【寧缺勿濫】的原則。<br>所以外表看似開放大方的她們，事實上一點也不濫情。'
      break;
    case 1:
      result[0]=90
      result[1]='<br>雙方都能表達最真摯的愛意。<br>個性上的不同反而使得他們在相處時，<br>營造出令人銷魂的浪漫氣氛。<br><br>男人的骨子裡，或多或少有一點點自戀的成分，<br>很多事他也只關心自己，<br>對於情人的態度是──只要對方好好照顧自己即可，<br>如此他就可以不費心了。<br>是個與世無爭、樂觀和無為而治型的男人<br>認為人生應是享受樂趣，而不是每天擔憂的。<br><br>女生，溫柔、敏感、喜愛幻想。<br>這樣的女性，極具包容性，個性上十分寬宏大量<br>不會因為一些小事而耿耿於懷。<br>她懂得適時做出讓步，甚至犧牲自己，成就他人。<br>這樣的女性，很容易受外界的氣氛感染<br>心思十分敏銳，也能關注到他人的需要。'
      break;
    case 2:
      result[0]=85
      result[1]='<br>這對組合是一種相當輕鬆自在的關係<br>兩個人能互相學習並從彼此的長處中獲益良多。<br><br>男性的感情雖豐富，卻不一定有表達的勇氣<br>所以精神上通經常會承載許多的壓力，<br>歸咎起來，都是自己帶來的。<br>這種男性不怎麼愛出鋒頭，而且脾氣傾向於溫馴<br>個性上很隨和，所以人緣很好。 <br><br>女性在感情的處理上，不會太依賴情人的。<br>她們覺得相愛並不代表天天都要在一起。<br>一旦彼此培養出默契之後，她們便能信任對方。<br>崇尚自由和自我的空間，不喜歡受到束縛<br>和她們在一起，經常可以感受到輕鬆愉快的氣氛。<br>如果找不到真正喜歡的對象，她們寧可獨身。'
      break;
    case 3:
      result[0]=60
      result[1]='<br>這對組合是一彼此相愛，為民除害的組合<br>兩個人當情人，雖然會互相折磨<br>但剛好也只有彼此忍受得了對方。<br><br>男性會讓女生感覺很man<br>會懂的保護女生，但也顯示出大男人的一面<br>常常會想控制女生，幫女生決定<br>讓女生雖然有安全感<br>也會多少感受到壓力。<br><br>女性有自己的想法<br>會有自己的事業心，想要讓自己更好<br>有時會希望男人為她而改變<br>但往往需要磨合的時間超過預定<br>兩人為互相的剋星<br>相處越久，越吵感情越好'
      break;
    case 4:
      result[0]=70
      result[1]='<br>這兩人是走越遠感情越好<br>因為這兩人有著一旦認定對方，就會更容易放入感情。<br><br>男人也是不折不扣的樂觀主義者<br>認為天塌下來也有人替自己頂著<br>所以人生應是享受樂趣，而不是每天擔憂的。<br>但他們十分好面子<br>因此與女生的相處最大問題會出現在這。<br><br>女性外表矜持穩重，內在卻熱情如火。<br>通常是柔媚感性的，也十分多情。<br>在愛情的態度上，她們很少會不切實際的編織美夢，<br>所以不會以對方的外表來決定自己的喜厭。<br>她們所欣賞的，其實是那種誠懇，又忠於感情的對象。'
      break;
    case 5:
      result[0]=50
      result[1]='<br>這兩人相處像兩隻刺蝟<br>走的越近，越容易被對方刺傷。<br><br>男人擁有與生俱來的獨特魅力。<br>喜歡無拘無束的體驗人生百態，崇尚獨立自主的生活方式，<br>兩人世界的愛情生活固然甜美，但是太粘的感覺，<br>卻會令他害怕。不過雖然害怕兩人世界的緊迫感，<br>但是一個人過他又會嫌寂寞，<br>所以經常在獨自生活和兩人世界的矛盾中掙紮。 <br><br>這樣的女人，是個無可救藥的浪漫主義者。<br>天生就是愛情的動物，活著如果沒有了愛情，<br>就彷彿人生沒有了意義一般。<br>她們的想像力豐富，喜歡美麗與和諧的事物，<br>性格溫柔，心思敏銳<br>一旦愛上了對方，更會使出渾身解數，毫無保留的投入。'
      break;
    case 6:
      result[0]=75
      result[1]='<br>這兩人相處，只要記得一個大原則，就是不要操太多的心<br>凡事盡力就好，其他的，就聽天由命了。<br>能享受的時候就盡量的放開心來享受，不必計畫得太遠。 <br><br>男性在開朗的外表下，隱藏著一顆敏感的心。<br>這種男人其實十分多情，一旦發現自己愛上了對方，會馬上栽進去<br>開始的時候，甚至會無法自拔。<br>在這種人身上，你可以看見叛逆、善變、好動等多種面貌<br>他的個性是極端不同的性格特質相容並存的。 <br><br>女性十分戀家，對於情人和親人的關係十分重視。<br>她們希望對等的付出，也會期待對方用心經營感情。<br>對於文筆和口才好的男性，抗拒的能力很弱，<br>因為任何浪漫的行為都能打動她，<br>所以鮮花、燭光晚餐、一個窩心的小禮物、一個吻或一個擁抱，<br>都會令她感到幸福不已，文字的表達更是不在話下了。'
      break;
    case 7:
      result[0]=100
      result[1]='<br>這兩人相處，容易注意到對方的優點<br>相處起來容易陷在彼此的陪伴當中<br>是一組交往起來，會很甜蜜的情侶。<br><br>男人，天生便具備著近乎藝術家的氣質。<br>這種男性的魅力無法擋，一舉手一投足之間，<br>都散發了十足的男人味，讓女性無法抗拒。<br>他們真心，個性平和，盡管溫柔體貼，卻絕不濫情。<br>因此當他們說愛你的時候，就是最真摯的告白。<br><br>這類的女性，是最女性化的女人，<br>她們希望自己的伴侶能安撫、重視和呵護她們，<br>也喜歡沈浸在被寵愛的感覺之中。在感情生活中，<br>她們最怕出現冷場，孤獨會令她們恐懼，<br>所以幾乎無時不刻都希望能跟隨在伴侶身邊。'
      break;
    case 8:
      result[0]=55
      result[1]='<br>這兩人相處，最重要的是彼此需要常溝通<br>否則彼此容易私自為對方付出，又不常溝通<br>容易讓誤會越來越大，好意反而造成反感。<br><br>男人，是很典型的居家男子<br>他在感情的收放上，比較傾向於女性似的善感和細心。<br>與這種男子的相處要訣是，開朗大方的接受他所付出一切<br>聆聽他想說的，減少外出人擠人的不適和疲累。<br>當然如果能凡事採取主動，愛情的效率會更高<br>感情的進展也會一日千里。 <br><br>女人強而有力的性格<br>經常透過母性精神而嶄露出來，<br>所以是那種臨危不亂，反而能更勇敢堅定的人。<br>這樣的女性，喜歡和諧，對於生活的要求十分隨興，<br>沒有野心勃勃的自我要求和對外的企圖心。<br>她很容易受外界的氣氛感染<br>心思十分敏銳，也能關注到他人的需要。 '
      break;
    case 9:
      result[0]=85
      result[1]='<br><br>一方獨立，一方依賴<br>互相互補的個性，讓兩人能逐漸加溫<br>容易成為人家眼裡的歡喜冤家。<br><br>男人，是個不折不扣的個人主義者。<br>他們十分獨立，天生不喜歡拜託他人什麼，<br>凡事都會靠自己的能力完成。<br>他們不希望成為他人的負擔或壓力，<br>這種態度，也充分的反映在感情觀裏。 <br><br>女性，看似剛毅和嚴肅的樣子，流露出小女人的動人模樣。<br>脾氣多半十分溫和，個性也十分柔順<br>她們通常吃軟不吃硬，很多事情用溝通的方式，<br>最能令她們信服和接受。<br>對於感情的態度十分嚴謹的她們<br>經常三思而後行，不會只憑一股衝動來行事。'
      break;
    case 10:
      result[0]=80
      result[1]='<br>兩人都有面對感情的高情商<br>考慮太多，會成為彼此的障礙<br>放開一切，反而能造就意想不到的緣分<br><br>男人，能夠接受的是獨立自由的戀愛觀<br>和情人維持如友誼一般的關系，即使若即若離也不介意。<br>他們很懂得獨立生存之道，也很能享受獨處的樂趣。<br>這樣的男人，能夠自己一個人過得很好<br>並不太擅於與他人分享自己的心思和感覺。<br><br>女人，特性在於熱情大方，活力充沛。<br>她們的幽默感十足，樂觀積極<br>和她們在一起，經常可以感受到輕鬆愉快的氣氛。<br>這樣的女人，不會動不動就鬧情緒，怨天尤人。<br>這樣的女性，凡事都以樂觀或人事物的光明面來當成著眼點。'
      break;
    case 11:
      result[0]=40
      result[1]='<br>兩人其實當朋友比當情人更適合<br>但如果兩人都很努力，超越自己<br>也許真能跨過那道感情的界線<br><br>男人，個性十分審慎的他們，不會多表達自己的感情<br>所以也不要指望他會甜言蜜語。<br>對于他人，時常存有戒心，心防很重<br>所以經常將感情放在心中，<br>處於單戀或暗戀的狀態。<br>如果你想和這樣的男人交往，不妨多費點心<br>把握住機會，對他表白你的心意。<br><br>女人，最大的性格特質就在於談戀愛時容易一頭栽入<br>而且完全憑感覺行事。<br>有時未免會衝動行事，而後悔莫及。<br>也通常耐性不佳<br>對於事物極容易失去新鮮感。'
      break;
    case 12:
      result[0]=85
      result[1]='<br>兩人很容易陷入愛情的旋窩裡，<br>因為很容易注意到對方的優點，<br>但相處久了，也容易陷在不滿足的感覺中<br><br>男性，性格上野心勃勃，對生命中任何事，都會具備相當的企圖心。<br>這種男性不但自信，也頗傾向于大男人主義，<br>他會以女性的保護者自居。<br>不過如果女方的能力或成就比自己好，會有些許的不安。<br>這類型的男人，會希望能伴侶凡事能采納他的意見<br>凡事以他的意見為意見。 <br><br>女性，凡事喜歡變化的她們<br>很願意接受許多新事物，<br>在感情的處理上，也傾向於喜歡有新鮮感<br>不喜歡一成不變的感覺。<br>意外的驚喜和變換不同的約會地點<br>會令她們感到興奮不已。'      
      break;
    case 13:
      result[0]=95
      result[1]='<br>天生適合的一對，<br>所有的小事，在彼此之間都容易產生樂趣！<br><br>男人，喜歡發表高見，也喜歡聆聽<br>而且十分在意自己在他人心中的地位<br>因此喜歡聽贊美的話，受到他人的肯定<br>所以這樣的男性，需要的是出一些適可而止的鋒頭<br>讓他在他人的肯定聲中，也肯定自己。<br><br>女人，愛好自由，喜歡冒險和刺激的事。<br>她們不會造作的個性，正是迷人之處。<br>由於討厭束縛<br>因此對於愛人要求的承諾<br>和需要負起責任的地方，感到厭倦和抗拒。'
      break;
    case 14:
      result[0]=80
      result[1]='<br>一個重視穩重踏實，一個重精神生活<br>兩人如果互相理解<br>是一對很理想的搭配。<br><br>男人，責任感很重<br>託付給他的事，他必定全力以赴。<br>不過他並不是什麼事都會答應的那一型，<br>以這樣的角度來看，他是十分有原則的人，<br>而不是一個什麼都隨口答應，最後不了了之的人<br>又或者將所有的事都往自己的身上攬，最後累個半死。<br><br>這樣的女人，需要尊重她的個人空間，<br>多給她點自由，而且不要動不動就掃她的興<br>不然她會以迅雷不及掩耳的速度，馬上離開你。'
      break;
    case 15:
      result[0]=75
      result[1]='<br>就像跳舞一樣，雖然一開始會容易踩到對方的腳<br>但經過重蹈覆徹後，<br>你們將會會熟悉對方的節奏。<br><br>男性，在感情的道路上，通常不會寂寞<br>不過卻很難覓得真心相對的伴侶。<br>其實只要收起三心二意不專情的毛病<br>定下心來，才會有可能覓得真心。<br><br>女性，外表矜持穩重，內在卻熱情如火。<br>最好能從好朋友開始做起，與她們談笑風生<br>分享生活中的點滴，讓她們逐漸的信任妳<br>進而發生感情。<br>也能讓她們更放心的打開自己的心胸去接納你。'
      break;
    case 16:
      result[0]=75
      result[1]='<br>或許會花一點時間，但經過磨合<br>兩人會有意想不到的互補效果。<br><br>男性，心中希望的理想伴侶<br>也是對感情抱持誠懇態度的人<br>所以一旦被人玩弄，或是感情受到挫折<br>通常會極為痛苦。<br>這樣的人，一旦遇到了合適的對象<br>將能享受到最甜美的愛情果實。<br><br>女性，有時外表看似剛毅和嚴肅的樣子<br>被真情所感化，就會逐漸流露出小女人的動人模樣<br>實際的個性讓她們對於具有實用性的禮品有著強烈的好感<br>一套她們平常就在用的保養品，一件羊毛批肩等都會很適合。'
      break;
    case 17:
      result[0]=80
      result[1]='<br>平靜安穩的關係，<br>容易在小事中找到大樂趣，讓彼此快樂。<br><br>這類的男人，不會太對生命中的許多事去苛求。<br>很多事都是隨性隨緣，也因此給人一種散漫不積極的感覺。<br>對於愛情，有時也會給對方和他人一種無為而治的感覺。<br>這種人不太會主動追求什麼感情<br>水到渠成就行了，在一起也不會多作承諾<br>反正只要兩個人快快樂樂就好。  <br><br>這類型的女性，賢淑可靠，思想趨於傳統。<br>不過這種女性，也有內心堅強的一面。<br>音樂會或是電影的入場券，帶著溫暖居家味道的禮品都會很討喜。<br>她們希望自己的伴侶能安撫、重視和呵護她們。<br>有時卻也不自覺的造成對方的壓力。'
      break;
    case 18:
      result[0]=80
      result[1]='<br>兩人同樣是很體貼另外一半的，<br>容易陷入彼此比較對對方的付出程度！<br><br>男性，往往都有一些柔順的女性特質。<br>這並不是指他們很「娘娘腔」，缺少了一股男人<br>而是指他們像女性一般細心、思維敏捷，十分斯文和溫柔<br>對於異性和身邊的朋友，也十分關心。<br>因此他們很容易與某個特定的對象真心相處、相互瞭解。<br>女性，對於愛情存有一種完美想像的她們<br>有時會高估了愛情的美好，所以經常在現實生活中感到失望。<br>好在她們總是能以樂觀的心胸坦然面對一切<br>勇敢的追求所愛，熱忱不減。<br>在感情的處理上，也是節奏明快，獨立不會太依賴情人的。'
      break;
    case 19:
      result[0]=80
      result[1]='<br>彼此笨拙的地方，都可以讓你們互相扶持。<br>你們兩個人是很棒的關係，補足對方的不足一起成長。<br><br>男生其實是一個很在感情上很笨拙，卻認真的可愛的人。<br>或許不會說什麼有趣的笑話，反應好像也很冷，<br>但不管何時總是靜靜陪在女生的身邊。<br>反應總是慢一拍，是因為容易把女生的話認真看待。<br>想把最好的給女生。 <br><br>女生很聰明，坦率，是擁有自己的步調的人。<br>這樣的女生可靠的看起來毫無縫隙<br>有時說話有時或許讓男生很無奈，很不解<br>但其實女生回家容易默默後悔，這樣的自己。'
      break;
    default:
      result[0]=80
      result[1]='<br>兩人棋逢對手，同樣電力十足<br>他甚至比你還更具危險性，是會讓你感到不安的對象。<br><br>男人，大多能言善道，口才十分不錯。<br>也是談笑風生，讓週遭的人有如沐春風之感。<br>這類型的男人也是不折不扣的樂觀主義者<br>認為天塌下來也有人替自己頂著<br>所以人生應是享受樂趣，而不是每天擔憂的。<br><br>女生，特性在於熱情大方，活力充沛。<br>她們的幽默感十足，樂觀積極<br>和她們在一起，經常可以感受到輕鬆愉快的氣氛。<br>而且在擇偶的條件上，通常會開出【寧缺勿濫】的原則。<br>所以外表看似開放大方的她們，事實上一點也不濫情。'
      break;
  }
  return result
}


function wordToNumber(inputName1,inputName2){
  const str = inputName1+inputName2
  const arrayNumber = utfstring.stringToBytes(str)
  let number = 0
  arrayNumber.forEach(element => {
    number = number + element
  });
  
  let switchCase = number%20
  
  return determineResult(switchCase)
}




export default wordToNumber;



// WEBPACK FOOTER //
// ./src/helper/wordToNumberToSwitchCase.js